import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "d-flex px-3" }
const _hoisted_3 = { class: "w-100" }
const _hoisted_4 = { class: "d-flex" }


export default /*#__PURE__*/_defineComponent({
  props: {
    loading: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_el_skeleton_item = _resolveComponent("el-skeleton-item")!
  const _component_el_skeleton = _resolveComponent("el-skeleton")!

  return (__props.loading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_el_skeleton, {
          loading: __props.loading,
          animated: "",
          style: {"--el-skeleton-circle-size":"50px","width":"100%"}
        }, {
          template: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_el_skeleton_item, {
                variant: "circle",
                style: {"min-width":"50px"}
              }),
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_el_skeleton_item, {
                  class: "mx-1",
                  style: {"width":"20%"},
                  variant: "h3"
                }),
                _createVNode(_component_el_skeleton_item, {
                  class: "mx-1",
                  style: {"width":"80%"},
                  variant: "text"
                }),
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_el_skeleton_item, {
                    class: "mx-1",
                    style: {"width":"20%"},
                    variant: "text"
                  }),
                  _createVNode(_component_el_skeleton_item, {
                    class: "mx-1",
                    style: {"width":"20%"},
                    variant: "text"
                  })
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["loading"])
      ]))
    : _createCommentVNode("", true)
}
}

})